|
<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="carrera" [dato]="dato" titulo="Carrera / Coordinación académica"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form (ngSubmit)="ctrl.enviar()" [formGroup]="dato" name="form" novalidate>
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;">
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a (click)="ctrl.cargarCatalogo('niveles_educativos', 'nivel-educativo'); ctrl.cargarCatalogo('tipos_periodos', 'tipo-periodo'); ctrl.subir['logo'] = false" id="catalogos"></a>

                    <div class="columns">

                        <div class="column">

                            <label class="label">Tipo RVOE:</label>
                                                          <div class="control has-icons-left has-icons-right">
                                                            <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('tipo_rvoe').hasError('required')}">
                                                              <select class="select" name="tipo_rvoe" formControlName="tipo_rvoe">
                                                                <option value="ESTATAL"> ESTATAL </option>
                                                                <option value="FEDERAL"> FEDERAL </option>
                                                              </select>
                                                            </div>
                                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('tipo_rvoe').hasError('required')">
                                                              <i class="fa fa-warning"></i>
                                                            </span>
                                                            <span class="help is-danger" *ngIf="ctrl.dato.get('tipo_rvoe').hasError('required')">Este campo
                                                              es requerido.</span>
                                                          </div> 

                        </div>

                        <div class="column">
                            <label class="label">RVOE:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input [ngClass]="{'is-danger': ctrl.dato.get('rvoe').hasError('required')}" class="input" formControlName="rvoe" placeholder="RVOE" type="text">
                                <span *ngIf="ctrl.dato.get('rvoe').hasError('required')" class="icon is-small is-right">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                <span *ngIf="ctrl.dato.get('rvoe').hasError('required')" class="help is-danger">Este campo es
                                                          requerido.</span>
                            </p>
                        </div>

                        <div class="column">
                            <label class="label">Fecha de Acuerdo:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input [ngClass]="{'is-danger': ctrl.dato.get('fecha_acuerdo').hasError('required')}" class="input" formControlName="fecha_acuerdo" placeholder="fecha_acuerdo" type="date">
                                <span *ngIf="ctrl.dato.get('fecha_acuerdo').hasError('required')" class="icon is-small is-right">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                <span *ngIf="ctrl.dato.get('fecha_acuerdo').hasError('required')" class="help is-danger">Este campo es
                                                              requerido.</span>
                            </p>
                        </div>

                        
                    </div>

                    <div class="columns">
                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Nombre:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required')}" class="input" formControlName="nombre" placeholder="Nombre" type="text">
                                    <span *ngIf="ctrl.dato.get('nombre').hasError('required')" class="icon is-small is-right">
                                                    <i class="fa fa-warning"></i>
                                                </span>
                                    <span *ngIf="ctrl.dato.get('nombre').hasError('required')" class="help is-danger">Este campo es
                                                                        requerido.</span>
                                </p>
                            </div>
                        </div>
                        <div class="column is-4">
                            <label class="label">Sigla:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input [ngClass]="{'is-danger': ctrl.dato.get('sigla').hasError('required')}" class="input" formControlName="sigla" placeholder="Sigla" type="text">
                                <span *ngIf="ctrl.dato.get('sigla').hasError('required')" class="icon is-small is-right">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                <span *ngIf="ctrl.dato.get('sigla').hasError('required')" class="help is-danger">Este campo es
                                                              requerido.</span>
                            </p>
                        </div>
                        <div class="column is-4">
                            <label class="label">ID CARRERA:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input [ngClass]="{'is-danger': ctrl.dato.get('id_carrera').hasError('required')}" class="input" formControlName="id_carrera" placeholder="ID_CARRERA" type="text">
                                <span *ngIf="ctrl.dato.get('id_carrera').hasError('required')" class="icon is-small is-right">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                <span *ngIf="ctrl.dato.get('id_carrera').hasError('required')" class="help is-danger">Este campo es
                                                              requerido.</span>
                            </p>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <label class="label">No. de períodos:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input [ngClass]="{'is-danger': ctrl.dato.get('numero_periodos').hasError('required')}" class="input" formControlName="numero_periodos" placeholder="No. de períodos" type="number">
                                <span *ngIf="ctrl.dato.get('numero_periodos').hasError('required')" class="icon is-small is-right">
                                                    <i class="fa fa-warning"></i>
                                                </span>
                                <span *ngIf="ctrl.dato.get('numero_periodos').hasError('required')" class="help is-danger">Este campo
                                                                      es requerido.</span>
                            </p>
                        </div>

                        <div class="column">
                            <label class="label">Tipos periodos:</label>
                            <div class="control has-icons-left has-icons-right">
                                <ng-select2 (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.tipos_periodos_id)" [data]="ctrl.tipos_periodos" [disabled]="ctrl.tipos_periodos ? ctrl.tipos_periodos.length == 0 ? true : false : true" [options]="ctrl.optionSelect"
                                    [value]="ctrl.dato.controls.tipos_periodos_id.value" name="tipos_periodos_id"></ng-select2>
                                <span *ngIf="ctrl.dato.get('tipos_periodos_id').hasError('required')" class="icon is-small is-right">
                                                    <i class="fa fa-warning"></i>
                                                </span>
                                <span *ngIf="ctrl.dato.get('tipos_periodos_id').hasError('required')" class="help is-danger">Este campo es requerido</span>
                            </div>

                            <!-- <label class="label">Tipo periodo:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div [ngClass]="{'is-danger': ctrl.dato.get('tipos_periodos_id').hasError('required')}" class="select">
                                                    <select class="select" formControlName="tipos_periodos_id" name="tipos_periodos_id">
                                                        <option *ngFor="let val of ctrl.tipos_periodos" value="{{val.id}}">
                                                            {
                                                            {
                                                                val.nombre
                                                            }
                                                        }</option>
                                                    </select>
                                                </div>
                                                <span *ngIf="ctrl.dato.get('tipos_periodos_id').hasError('required')" class="icon is-small is-right">
                                                    <i class="fa fa-warning"></i>
                                                </span>
                                                <span *ngIf="ctrl.dato.get('tipos_periodos_id').hasError('required')" class="help is-danger">Este campo
                                                                      es requerido.</span>
                                            </div> -->
                        </div>

                        <div class="column">
                            <label class="label">Nivel educativo:</label>
                            <!--<div class="control has-icons-left has-icons-right">  
                                <ng-select2 (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.nivel_educativo)" [data]="ctrl.niveles_educativos" [disabled]="ctrl.niveles_educativos ? ctrl.niveles_educativos.length == 0 ? true : false : true" [options]="ctrl.optionSelect"
                                    [value]="ctrl.dato.controls.nivel_educativo.value" name="nivel_educativo"></ng-select2>
                                <span *ngIf="ctrl.dato.get('nivel_educativo').hasError('required')" class="icon is-small is-right">
                                                    <i class="fa fa-warning"></i>
                                                </span>
                                <span *ngIf="ctrl.dato.get('nivel_educativo').hasError('required')" class="help is-danger">Este campo es requerido.</span>
                            </div>-->

                            <div class="control has-icons-left has-icons-right">  
                                <ng-select2 (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.niveles_educativos_id)" [data]="ctrl.niveles_educativos" [disabled]="ctrl.niveles_educativos ? ctrl.niveles_educativos.length == 0 ? true : false : true" [options]="ctrl.optionSelect"
                                    [value]="ctrl.dato.controls.niveles_educativos_id.value" name="niveles_educativos_id"></ng-select2>
                                <span *ngIf="ctrl.dato.get('niveles_educativos_id').hasError('required')" class="icon is-small is-right">
                                                    <i class="fa fa-warning"></i>
                                                </span>
                                <span *ngIf="ctrl.dato.get('niveles_educativos_id').hasError('required')" class="help is-danger">Este campo es requerido.</span>
                            </div>
                            <!-- <label class="label">Nivel educativo:</label>
                                                          <div class="control has-icons-left has-icons-right">
                                                            <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('nivel_educativo').hasError('required')}">
                                                              <select class="select" name="nivel_educativo" formControlName="nivel_educativo">
                                                                <option value="Preescolar"> PREESCOLAR </option>
                                                                <option value="Primaria"> PRIMARIA </option>
                                                                <option value="Secundaria"> SECUNDARIA </option>
                                                                <option value="Profesional Técnico"> PROFESIONAL TÉCNICO </option>
                                                                <option value="Bachillerato"> BACHILLERATO</option>
                                                                <option value="Licenciatura"> LICENCIATURA</option>
                                                              </select>
                                                            </div>
                                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nivel_educativo').hasError('required')">
                                                              <i class="fa fa-warning"></i>
                                                            </span>
                                                            <span class="help is-danger" *ngIf="ctrl.dato.get('nivel_educativo').hasError('required')">Este campo
                                                              es requerido.</span>
                                                          </div> -->
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="box">
                                <article class="media">
                                    <div class="media-left">
                                        <figure class="image is-64x64">
                                            <img *ngIf="ctrl.subir['logo']" [src]="'data:image/jpeg;base64,'+ctrl.dato.get('logo').value">
                                            <img *ngIf="!ctrl.subir['logo']" [src]="ctrl.dato.get('logo').value != '' ? ctrl.API_PATH + '/adjunto/carrera/' + ctrl.dato.controls.logo.value  : './assets/128x128.png'"></figure>
                                    </div>
                                    <div class="media-content">
                                        <div class="field">
                                            <label class="label">Logo:</label>
                                            <div *ngIf="ctrl.dato.get('logo').value == ''" class="control has-icons-left has-icons-right">

                                                <div class="file has-name">
                                                    <label class="file-label">
                                                                                <input (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.logo, false, 'logo')" accept="image/x-png,image/gif,image/jpeg,image/jpg" class="file-input" type="file">
                                                                                    <span class="file-cta">
                                                                                        <span class="file-icon">
                                                                                            <i class="fa fa-upload"></i>
                                                                                        </span>
                                                                                        <span class="file-label">
                                                                                            Seleccionar archivo
                                                                                        </span>
                                                                                    </span>

                                                                                </label>
                                                </div>
                                            </div>
                                            <input formControlName="logo" foto type="hidden">
                                            <button (click)="ctrl.borrarImagen($event, ctrl.dato.controls.logo, 'carrera')" *ngIf="ctrl.dato.get('logo').value != ''" class="button is-danger" type="button">
                                                                                <span class="icon">
                                                                                    <i class="fa fa-trash"></i>
                                                                                </span>
                                                                                &nbsp; Eliminar logo.
                                                                            </button>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>

                    </div>
                </section>
            </form>
        </div>
    </div>
</div>